var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Title',{attrs:{"text":_vm.home.AlarmStatistics.Title[0],"engText":_vm.home.AlarmStatistics.Title[1]}}),_c('div',{staticClass:"echarts-content"},[_c('chart-block',{ref:"a"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }